<template>
	<section class="marketing-section bg-color-white">
		<MarketingPageHeader :header="sectionHeader" :is-secondary="false" :has-outer-spacing="false" />
		<div class="container col-8-lg">
			<FeaturedStats :stats="stats" :horizontally-aligned="false" :add-container-class="false">
				<template #disclaimer>
					<p class="body-xs text-color-content-tertiary text-align-center mt-250">
						<BaseButton
							classes="text-decoration-underline text-color-current-color"
							@click="openLearnMoreModal"
						>
							Learn more
						</BaseButton>
						about the assumptions of this section, or view
						<BaseLink class="text-decoration-underline text-color-current-color" :link="disclosuresLink"
							>full&nbsp;disclosure</BaseLink
						>.
					</p>
				</template>
			</FeaturedStats>
		</div>
	</section>
</template>

<script setup lang="ts">
import DisclaimerSimple from '@components/disclaimer/disclaimer-simple.vue';
import { disclosuresLink } from '@constants/links';
import { FeaturedStat } from 'types/marketing-site';
import FeaturedStats from '@components/marketing-site/featured-stats.vue';
import { LandingPageHeader } from 'types/layout';
import MarketingPageHeader from '@components/marketing-site/marketing-page-header.vue';
import { useAppStore } from '@stores/app';

interface Props {
	stats?: Array<FeaturedStat>;
}

withDefaults(defineProps<Props>(), {
	stats: () => [
		{
			stat: '$930 million',
			description: 'Capital Deployed into Debt Projects'
		},
		{
			stat: '138',
			description: '# of Deals'
		},
		{
			stat: '23,923',
			description: '# of Units'
		},
		{
			stat: '11.5%',
			description: 'Avg. Net Interest Rate'
		}
	]
});

const appStore = useAppStore();

const sectionHeader: LandingPageHeader = {
	title: 'Our Private Credit Track Record',
	heading: 'Billion-dollar experience',
	summary: [
		`While this strategy is newly calibrated for this environment, we’re able to draw on a deep well of executional experience. Since 2012, we’ve acquired or financed over 46,000 residential units and have made more than 129 unique mezzanine and preferred equity investments in real estate.`
	]
};

const learnMoreModalContent = [
	`Figures as of 7/1/2025. Average net interest rate is calculated as the weighted rate across all private debt investments.`
];

function openLearnMoreModal(): void {
	appStore.updateCurrentModal({
		modal: DisclaimerSimple,
		props: {
			content: learnMoreModalContent,
			centeredContent: false
		}
	});
}
</script>
<style lang="scss" scoped>
.track-record-body {
	max-width: 720px;
	margin-right: auto;
	margin-left: auto;
}
</style>
